// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-favourites-indexstyleGrid-container-gylew{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-favourites-indexstyleGrid-grid-bglpt{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-favourites-indexstyleGrid-col6-bgebp{grid-column:span 6}.pages-favourites-indexstyleGrid-col3-bmtzc{grid-column:span 3}.pages-favourites-indexstyleGrid-col4-cbtra{grid-column:span 4}.pages-favourites-indexstyleGrid-col9-bxqvh{grid-column:span 9}.pages-favourites-indexstyleGrid-col12-bpcvg{grid-column:span 12}.pages-favourites-indexstyleGrid-alignItemsStart-cddac{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-favourites-indexstyleGrid-container-gylew",
	"grid": "pages-favourites-indexstyleGrid-grid-bglpt",
	"col6": "pages-favourites-indexstyleGrid-col6-bgebp",
	"col3": "pages-favourites-indexstyleGrid-col3-bmtzc",
	"col4": "pages-favourites-indexstyleGrid-col4-cbtra",
	"col9": "pages-favourites-indexstyleGrid-col9-bxqvh",
	"col12": "pages-favourites-indexstyleGrid-col12-bpcvg",
	"alignItemsStart": "pages-favourites-indexstyleGrid-alignItemsStart-cddac"
};
module.exports = ___CSS_LOADER_EXPORT___;
